module.exports = __webpack_public_path__ + "img/6.51c90941.png";